module.exports = __webpack_public_path__ + "img/安全巡检.2656b648.png";